import BasicPublicI18nSetup from 'I18n/init/setup/BasicPublicI18nSetup';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import { jsx as _jsx } from "react/jsx-runtime";
function changeLocale(locale, language) {
  const langEnabled = language !== 'en';
  return BasicPublicI18nSetup.setup({
    lang,
    manualLocaleSettings: {
      langEnabled,
      locale
    }
  });
}
export default function connectI18nLoader(WrappingComponent) {
  function I18nLoader(props) {
    return /*#__PURE__*/_jsx(WrappingComponent, Object.assign({}, props, {
      changeLocale: changeLocale
    }));
  }
  I18nLoader.displayName = WrappingComponent.displayName ? `connectI18nLoader(${WrappingComponent.displayName})` : 'connectI18nLoader(Component)';
  return I18nLoader;
}